export const CREATE_COLLABORATOR = 'CREATE_COLLABORATOR';
export const CREATE_COLLABORATOR_SUCCESS = 'CREATE_COLLABORATOR_SUCCESS';
export const CREATE_COLLABORATOR_FAIL = 'CREATE_COLLABORATOR_FAIL';
export const EDIT_COLLABORATOR_INFO = 'EDIT_COLLABORATOR_INFO';
export const EDIT_COLLABORATOR_INFO_SUCCESS = 'EDIT_COLLABORATOR_INFO_SUCCESS';
export const EDIT_COLLABORATOR_INFO_FAIL = 'EDIT_COLLABORATOR_INFO_FAIL';
export const CANCEL_COLLABORATOR_INFO = 'CANCEL_COLLABORATOR_INFO';
export const RESET_COLLABORATOR_INFO = 'RESET_COLLABORATOR_INFO';
